import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {buildUrlFromFields} from '../../../common/functions/url'
import {
  validateVacancyCriteriaVoiceActorField
} from '../../../../actions/pages/vacancy-page'
import SearchForm from '../../../common/form/SearchFormCriteria'
import MultiSelect from '../../../common/form/MultiSelectTalentSearch'
import MultiSelectAutoComplete from '../../../common/form/MultiSelectAutoCompleteCriteria'
import ReactSelectTalentSearch from '../../../common/form/ReactSelectTalentSearch'
import Select from '../../../common/form/ReactSelectTalentSearch'
import CheckboxField from "../../../common/form/CheckboxFieldTalentSearch";
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify'
import VoiceTestCriteriaResult from '../VoiceTestCriteriaResult'
import ProtectedElement from '../../../common/helpers/ProtectedElement'
import InputField from '../../../common/form/InputField'
import {
    PERMISSION_VACANCIES_CRITERIA_WRITE
  } from '../../../../constants'

import { Collapse, CardBody, Card } from 'reactstrap';

class VoiceTestSoundEngineerCriteria extends Component {
  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this)
    this.onSave = this.onSave.bind(this)
    this.toggleBasicDetails = this.toggleBasicDetails.bind(this);
    this.toggleVoiceActor = this.toggleVoiceActor.bind(this);
    this.toggleCast = this.toggleCast.bind(this);
    this.toggleBooker = this.toggleBooker.bind(this);
    this.toggleSinger = this.toggleSinger.bind(this);
    this.toggleDirector = this.toggleDirector.bind(this);
    this.toggleLyricist = this.toggleLyricist.bind(this);
    this.toggleTranslator = this.toggleTranslator.bind(this);
    this.toggleEditor = this.toggleEditor.bind(this);
    this.toggleAdaptor = this.toggleAdaptor.bind(this);
    this.toggleSoundEngineer = this.toggleSoundEngineer.bind(this);
    this.getVoiceActorStudioId = this.getVoiceActorStudioId.bind(this);
    this.getVoiceActorClientId = this.getVoiceActorClientId.bind(this);
    this.getVoiceActorSchoolId = this.getVoiceActorSchoolId.bind(this);
    this.getProductionId = this.getProductionId.bind(this)
    this.getBookerStudioId = this.getBookerStudioId.bind(this);
    this.getVacancyId = this.getVacancyId.bind(this)
    this.getExternalExperienceId = this.getExternalExperienceId.bind(this)
    this.getSingerStudioId = this.getSingerStudioId.bind(this);
    this.getSingerClientId = this.getSingerClientId.bind(this);
    this.getSingerSchoolId = this.getSingerSchoolId.bind(this);
    this.getDirectorStudioId = this.getDirectorStudioId.bind(this);
    this.getDirectorClientId = this.getDirectorClientId.bind(this);
    this.getLyricistStudioId = this.getLyricistStudioId.bind(this);
    this.getLyricistClientId = this.getLyricistClientId.bind(this);
    this.getDirectorSchoolId = this.getDirectorSchoolId.bind(this);
    this.getTranslatorStudioId = this.getTranslatorStudioId.bind(this);
    this.getTranslatorClientId = this.getTranslatorClientId.bind(this);
    this.getEditorStudioId = this.getEditorStudioId.bind(this);
    this.getEditorClientId = this.getEditorClientId.bind(this);
    this.getEditorSchoolId = this.getEditorSchoolId.bind(this);
    this.getAdaptorStudioId = this.getAdaptorStudioId.bind(this);
    this.getAdaptorClientId = this.getAdaptorClientId.bind(this);
    this.getSoundEngineerStudioId = this.getSoundEngineerStudioId.bind(this);
    this.getSoundEngineerClientId = this.getSoundEngineerClientId.bind(this);
    this.getSoundEngineerSchoolId = this.getSoundEngineerSchoolId.bind(this);

    this.timeout = 0;


    this.state = {
      collapseBasicDetails: false,
      collapseVoiceActor: false,
      collapseCast: false,
      collapseBooker: false,
      collapseSinger: false,
      collapseLyricist: false,
      collapseTranslator: false,
      collapseEditor: false,
      collapseAdaptor: false,
      collapseSoundEngineer: false,
      dataSearch:'',
      voiceActorStudioId:'',
      voiceActorClientId:'',
      voiceActorSchoolId:'',
      productionId:'',
      vacancyId:'',
      externalExperienceId:'',
      externalExperience: this.props.externalExperienceCast,
      bookerStudioId:'',
      singerStudioId:'',
      singerClientId:'',
      singerSchoolId:'',
      directorStudioId:'',
      directorClientId:'',
      directorSchoolId:'',
      lyricistStudioId:'',
      lyricistClientId:'',
      translatorStudioId:'',
      translatorClientId:'',
      editorClientId:'',
      editorSchoolId:'',
      editorStudioId:'',
      adaptorClientId:'',
      adaptorStudioId:'',
      soundEngineerStudioId:'',
      soundEngineerClientId:'',
      soundEngineerSchoolId:'',
      items:[],
      personalCounter: '',
      directorCounter:'',
      translatorCounter:'',
      adaptorCounter:'',
      lyricistCounter:'',
      actorCounter:'',
      singerCounter:'',
      editorCounter:'',
      soundEngineerCounter:'',
      bookerCounter:'',
      castCounter:''

    }
  }

  componentDidMount() {
    //click saveCriteria from parent(Criteria)
    this.props.setClick(this.onSave);

    //this.onSearch();
    //it should be interval cause state not set yet in fields autocomplete
    if(this.timeout) clearTimeout(this.timeout);
     this.timeout = setTimeout(() => {
       this.onSearch();
     }, 1000);

 }

 countSelectedFilters(items, profileTypeNumberTwoFirstNumbers){
    let profileTypeItemsArr = items.filter((item) => item.SearchProperty.toString().length>2);
    let counterArr = [];
    profileTypeItemsArr.map((element) =>{
      let str = element.SearchProperty.toString();
      if(str.substring(0,2) == profileTypeNumberTwoFirstNumbers){
          counterArr.push(element.SearchProperty);
      }
    });
    return  counterArr.length;
  }

  getVoiceActorStudioId(id){
    this.setState({voiceActorStudioId:id})
  }

  getVoiceActorSchoolId(id){
    this.setState({voiceActorSchoolId:id})
  }

  getVoiceActorClientId(id){
    this.setState({voiceActorClientId:id})
  }


  getProductionId(id){
    this.setState({
      productionId:id
    })
  }

  getBookerStudioId(id){
    this.setState({bookerStudioId:id})
  }

  getVacancyId(id){
    this.setState({
      vacancyId:id
    })
  }


  getExternalExperienceId(id){
    this.setState({
      externalExperienceId:id
    })
  }

  getSingerStudioId(id){
    this.setState({singerStudioId:id})
  }

  getSingerSchoolId(id){
    this.setState({singerSchoolId:id})
  }

  getSingerClientId(id){
    this.setState({singerClientId:id})
  }

  getDirectorStudioId(id){
    this.setState({directorStudioId:id})
  }

  getDirectorSchoolId(id){
    this.setState({directorSchoolId:id})
  }

  getDirectorClientId(id){
    this.setState({directorClientId:id})
  }

  getLyricistStudioId(id){
    this.setState({lyricistStudioId:id})
  }

  getLyricistClientId(id){
    this.setState({lyricistClientId:id})
  }

  getTranslatorStudioId(id){
    this.setState({translatorStudioId:id})
  }

  getTranslatorClientId(id){
    this.setState({translatorClientId:id})
  }

  getEditorStudioId(id){
    this.setState({editorStudioId:id})
  }

  getEditorSchoolId(id){
    this.setState({editorSchoolId:id})
  }

  getEditorClientId(id){
    this.setState({editorClientId:id})
  }

  getAdaptorStudioId(id){
    this.setState({adaptorStudioId:id})
  }

  getAdaptorClientId(id){
    this.setState({adaptorClientId:id})
  }

  getSoundEngineerSchoolId(id){
    this.setState({soundEngineerSchoolId:id})
  }

  getSoundEngineerClientId(id){
    this.setState({soundEngineerClientId:id})
  }

  getSoundEngineerStudioId(id){
    this.setState({soundEngineerStudioId:id})
  }

  getFieldValue(fieldName) {
    var field = this.props.fields.find((el) => {
      return el.name === fieldName;
    });
    return field.value;
  }

  onSearch() {
    let data={};
    let items =[];

    let fields = this.props.fields;



    let url = 'vacancies/' + this.props.vacancyId + '/getSkillVendorsByCriteria';

    var skillLevelFieldValue = this.getFieldValue("SkillLevel");
    var skillTypeFieldValue = this.getFieldValue("SkillType");
    var nativeLanguageFieldValue = this.getFieldValue("NativeLanguage");
    var additionalLanguageFieldValue = this.getFieldValue("AdditionalLanguage");
    var countryofLivingFieldValue = this.getFieldValue("CountryofLiving");
    var cityFieldValue = this.getFieldValue("City");
    var regionFieldValue = this.getFieldValue("Region");
    var ethnicityFieldValue = this.getFieldValue("Ethnicity");
    var identityFieldValue = this.getFieldValue("Identity");
    var ageFromFieldValue = this.getFieldValue("AgeFrom");
    var ageToFieldValue = this.getFieldValue("AgeTo");
    // var skillVendorStatusFieldValue = this.getFieldValue("SkillVendorStatus");
    var doNotUseFieldValue = this.getFieldValue("DoNotUse");
    var knownTalentFieldValue = this.getFieldValue("KnownTalent");

    var externalExperienceFieldValue = this.getFieldValue("ExternalExperience");
    var productionFieldValue = this.getFieldValue("Production");
    var vacancyFieldValue = this.getFieldValue("Vacancy");


    //VoiceActor
    var voiceActorDubbingExperienceFieldValue = this.getFieldValue("VoiceActorDubbingExperience");
    var voiceActorAudiobooksExperienceFieldValue = this.getFieldValue("VoiceActorAudiobooksExperience");
    var voiceActorVoiceOverExperienceFieldValue = this.getFieldValue("VoiceActorVoiceOverExperience");
    var voiceActorRadioExperienceFieldValue = this.getFieldValue("VoiceActorRadioExperience");
    var voiceActorTheatreActorExperienceFieldValue = this.getFieldValue("VoiceActorTheatreActorExperience");
    var voiceActorMovieActorExperienceFieldValue = this.getFieldValue("VoiceActorMovieActorExperience");
    var voiceActorAudioDescriptionExperienceFieldValue = this.getFieldValue("VoiceActorAudioDescriptionExperience");
    var voiceActorTheatricalExperienceFieldValue = this.getFieldValue("VoiceActorTheatricalExperience");
    var voiceActorTVExperienceFieldValue = this.getFieldValue("VoiceActorTVExperience");
    var voiceActorGamesExperienceFieldValue = this.getFieldValue("VoiceActorGamesExperience");
    var voiceActorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("VoiceActorPromoOrCommercialsExperience");
    var voiceActorLiveActionExperienceFieldValue = this.getFieldValue("VoiceActorLiveActionExperience");
    var voiceActorAnimationExperienceFieldValue = this.getFieldValue("VoiceActorAnimationExperience");
    var voiceActorRemoteRecordingCapabilityFieldValue = this.getFieldValue("VoiceActorRemoteRecordingCapability");
    var voiceActorLiveActionMaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorLiveActionMaleVoiceGender");
    var voiceActorLiveActionFemaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorLiveActionFemaleVoiceGender");
    var voiceActorAnimationMaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorAnimationMaleVoiceGender");
    var voiceActorAnimationFemaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorAnimationFemaleVoiceGender");
    var voiceActorSchoolsFieldValue = this.getFieldValue("VoiceActorSchools");
    var voiceActorStudiosFieldValue = this.getFieldValue("VoiceActorStudios");
    var voiceActorClientsFieldValue = this.getFieldValue("VoiceActorClients");
    var voiceActorVoiceAgeRangeFieldValue = this.getFieldValue("VoiceActorVoiceAge");
    var voiceActorVoiceTypeFieldValue = this.getFieldValue("VoiceActorVoiceType");
    var voiceActorLanguageAccentFieldValue = this.getFieldValue("VoiceActorLanguageAccent");
    var voiceActorUnionFieldValue = this.getFieldValue("VoiceActorUnion");
    var voiceActorGenderNeutralVoiceFieldValue = this.getFieldValue("VoiceActorGenderNeutralVoice");
    var voiceActorDoNotUseFieldValue = this.getFieldValue("VoiceActorDoNotUse");

    //booker
    var bookerStudiosFieldValue = this.getFieldValue("BookerStudios");
    var bookerTheatricalExperienceFieldValue = this.getFieldValue("BookerTheatricalExperience");
    var bookerTVExperienceFieldValue = this.getFieldValue("BookerTVExperience");
    var bookerInteractiveExperienceFieldValue = this.getFieldValue("BookerInteractiveExperience");
    var bookerDoNotUseFieldValue = this.getFieldValue("BookerDoNotUse");

    //Singer
    var singerDubbingExperienceFieldValue = this.getFieldValue("SingerDubbingExperience");
    var singerStageExperienceFieldValue = this.getFieldValue("SingerStageExperience");
    var singerTheatreExperienceFieldValue = this.getFieldValue("SingerTheatreExperience");
    var singerTalentShowExperienceFieldValue = this.getFieldValue("SingerTalentShowExperience");
    var singerMaleVoiceGenderFieldValue = this.getFieldValue("SingerMaleVoiceGender");
    var singerFemaleVoiceGenderFieldValue = this.getFieldValue("SingerFemaleVoiceGender");
    var singerVocalRangeFieldValue = this.getFieldValue("SingerVocalRange");
    var singerMusicNotesReadingLevelFieldValue = this.getFieldValue("SingerMusicNotesReadingLevel");
    var singerVoiceAgeRangeFieldValue = this.getFieldValue("SingerVoiceAge");
    var singerSchoolsFieldValue = this.getFieldValue("SingerSchools");
    var singerStudiosFieldValue = this.getFieldValue("SingerStudios");
    var singerClientsFieldValue = this.getFieldValue("SingerClients");
    var singerRemoteRecordingCapabilityFieldValue = this.getFieldValue("SingerRemoteRecordingCapability");
    var singerUnionFieldValue = this.getFieldValue("SingerUnion");
    var singerGenderNeutralVoiceFieldValue = this.getFieldValue("SingerGenderNeutralVoice");
    var singerDoNotUseFieldValue = this.getFieldValue("SingerDoNotUse");

    //Director
    var directorDubbingDirectorExperienceFieldValue = this.getFieldValue("DirectorDubbingDirectorExperience");
    var directorVoiceOverDirectorExperienceFieldValue = this.getFieldValue("DirectorVoiceOverDirectorExperience");
    var directorSongDirectorExperienceFieldValue = this.getFieldValue("DirectorSongDirectorExperience");
    var directorDubbingActorExperienceFieldValue = this.getFieldValue("DirectorDubbingActorExperience");
    var directorStageDirectorExperienceFieldValue = this.getFieldValue("DirectorStageDirectorExperience");
    var directorMovieDirectorExperienceFieldValue = this.getFieldValue("DirectorMovieDirectorExperience");
    var directorTheatricalExperienceFieldValue = this.getFieldValue("DirectorTheatricalExperience");
    var directorTVExperienceFieldValue = this.getFieldValue("DirectorTVExperience");
    var directorGamesExperienceFieldValue = this.getFieldValue("DirectorGamesExperience");
    var directorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("DirectorPromoOrCommercialsExperience");
    var directorLiveActionExperienceFieldValue = this.getFieldValue("DirectorLiveActionExperience");
    var directorAnimationExperienceFieldValue = this.getFieldValue("DirectorAnimationExperience");
    var directorAudioDescriptionExperienceFieldValue = this.getFieldValue("DirectorAudioDescriptionExperience");
    var directorAudioDescriptionExperienceFieldValue = this.getFieldValue("DirectorAudioDescriptionExperience");
    var directorRemoteRecordingCapabilityFieldValue = this.getFieldValue("DirectorRemoteRecordingCapability");
    var directorAppAccessRevokedFieldValue = this.getFieldValue("DirectorAppAccessRevoked");
    var directorSchoolsFieldValue = this.getFieldValue("DirectorSchools");
    var directorStudiosFieldValue = this.getFieldValue("DirectorStudios");
    var directorClientsFieldValue = this.getFieldValue("DirectorClients");
    var directorDoNotUseFieldValue = this.getFieldValue("DirectorDoNotUse");

    //lyricist
    var lyricistExperienceFieldValue = this.getFieldValue("LyricistExperience");
    var lyricistDubbingExperienceFieldValue = this.getFieldValue("LyricistDubbingExperience");
    var lyricistMusicianExperienceFieldValue = this.getFieldValue("LyricistMusicianExperience");
    var lyricistNumberOfSongsWrittenFieldValue = this.getFieldValue("LyricistNumberOfSongsWritten");
    var lyricistRemoteRecordingCapabilityFieldValue = this.getFieldValue("LyricistRemoteRecordingCapability");
    var lyricistMusicalExperienceFieldValue = this.getFieldValue("LyricistMusicalExperience");
    var lyricistTheatreExperienceFieldValue = this.getFieldValue("LyricistTheatreExperience");
    var lyricistPromoOrCommercialsExperienceFieldValue = this.getFieldValue("LyricistPromoOrCommercialsExperience");
    var lyricistUniversityDegreeFieldValue = this.getFieldValue("LyricistUniversityDegree");
    var lyricistStudiosFieldValue = this.getFieldValue("LyricistStudios");
    var lyricistClientsFieldValue = this.getFieldValue("LyricistClients");
    var lyricistDoNotUseFieldValue = this.getFieldValue("LyricistDoNotUse");

    //Translator
    var translatorSubtitlesExperienceFieldValue = this.getFieldValue("TranslatorSubtitlesExperience");
    var translatorDubbingExperienceFieldValue = this.getFieldValue("TranslatorDubbingExperience");
    var translatorVoiceOverExperienceFieldValue = this.getFieldValue("TranslatorVoiceOverExperience");
    var translatorGamingExperienceFieldValue = this.getFieldValue("TranslatorGamingExperience");
    var translatorAudioDescriptionExperienceFieldValue = this.getFieldValue("TranslatorAudioDescriptionExperience");
    var translatorHOHSDHCCEExperienceFieldValue = this.getFieldValue("TranslatorHOHSDHCCExperience");
    var translatorNumberOfTranslationsFieldValue = this.getFieldValue("TranslatorNumberOfTranslations");
    var translatorTheatricalExperienceFieldValue = this.getFieldValue("TranslatorTheatricalExperience");
    var translatorTVExperienceFieldValue = this.getFieldValue("TranslatorTVExperience");
    var translatorGamesExperienceFieldValue = this.getFieldValue("TranslatorGamesExperience");
    var translatorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("TranslatorPromoOrCommercialsExperience");
    var translatorLiveActionExperienceFieldValue = this.getFieldValue("TranslatorLiveActionExperience");
    var translatorAnimationExperienceFieldValue = this.getFieldValue("TranslatorAnimationExperience");
    var translatorUniversityDegreeFieldValue = this.getFieldValue("TranslatorUniversityDegree");
    var translatorStudiosFieldValue = this.getFieldValue("TranslatorStudios");
    var translatorClientsFieldValue = this.getFieldValue("TranslatorClients");
    var translatorDoNotUseFieldValue = this.getFieldValue("TranslatorDoNotUse");



    //Editor
    var editorRecordingEditingExperienceFieldValue = this.getFieldValue("EditorRecordingEditingExperience");
    var editorDialogueEditingExperienceFieldValue = this.getFieldValue("EditorDialogueEditingExperience");
    var editorMusicAndEffectsExperienceFieldValue = this.getFieldValue("EditorMusicAndEffectsExperience");
    var editorMixEditingExperienceFieldValue = this.getFieldValue("EditorMixEditingExperience");
    var editorPreparingTakesExperienceFieldValue = this.getFieldValue("EditorPreparingTakesExperience");
    var editorDubbingExperienceFieldValue = this.getFieldValue("EditorDubbingExperience");
    var editorVoiceOverExperienceFieldValue = this.getFieldValue("EditorVoiceOverExperience");
    var editorSongsExperienceFieldValue = this.getFieldValue("EditorSongsExperience");
    var editorProToolsExperienceFieldValue = this.getFieldValue("EditorProToolsExperience");
    var editorDolby51ExperienceFieldValue = this.getFieldValue("EditorDolby51Experience");
    var editorAtmosExperienceFieldValue = this.getFieldValue("EditorAtmosExperience");
    var editorFoleyExperienceFieldValue = this.getFieldValue("EditorFoleyExperience");
    var editorAudioDescriptionExperienceFieldValue = this.getFieldValue("EditorAudioDescriptionExperience");
    var editorSchoolsFieldValue = this.getFieldValue("EditorSchools");
    var editorStudiosFieldValue = this.getFieldValue("EditorStudios");
    var editorClientsFieldValue = this.getFieldValue("EditorClients");
    var editorRemoteRecordingCapabilityFieldValue = this.getFieldValue("EditorRemoteRecordingCapability");
    var editorDoNotUseFieldValue = this.getFieldValue("EditorDoNotUse");



    //Adaptor
    var adaptorAdaptorExperienceFieldValue = this.getFieldValue("AdaptorAdaptorExperience");
    var adaptorDubbingDirectorExperienceFieldValue = this.getFieldValue("AdaptorDubbingDirectorExperience");
    var adaptorTranslatorExperienceFieldValue = this.getFieldValue("AdaptorTranslatorExperience");
    var adaptorVoiceActorExperienceFieldValue = this.getFieldValue("AdaptorVoiceActorExperience");
    var adaptorTheatricalExperienceFieldValue = this.getFieldValue("AdaptorTheatricalExperience");
    var adaptorTVExperienceFieldValue = this.getFieldValue("AdaptorTVExperience");
    var adaptorGamesExperienceFieldValue = this.getFieldValue("AdaptorGamesExperience");
    var adaptorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("AdaptorPromoOrCommercialsExperience");
    var adaptorLiveActionExperienceFieldValue = this.getFieldValue("AdaptorLiveActionExperience");
    var adaptorAnimationExperienceFieldValue = this.getFieldValue("AdaptorAnimationExperience");
    var adaptorAudioDescriptionExperienceFieldValue = this.getFieldValue("AdaptorAudioDescriptionExperience");
    var adaptorNumberOfAdaptionsFieldValue = this.getFieldValue("AdaptorNumberOfAdaptionsRange");
    var adaptorUniversityDegreeFieldValue = this.getFieldValue("AdaptorUniversityDegree");
    var adaptorStudiosFieldValue = this.getFieldValue("AdaptorStudios");
    var adaptorClientsFieldValue = this.getFieldValue("AdaptorClients");
    var adaptorDoNotUseFieldValue = this.getFieldValue("AdaptorDoNotUse");

    //SoundEngineer
    var soundEngineerDialogueRecordingExperienceFieldValue = this.getFieldValue("SoundEngineerDialogueRecordingExperience");
    var soundEngineerSongRecordingExperienceFieldValue = this.getFieldValue("SoundEngineerSongRecordingExperience");
    var soundEngineerDialogueMixingExperienceFieldValue = this.getFieldValue("SoundEngineerDialogueMixingExperience");
    var soundEngineerSongMixingExperienceFieldValue = this.getFieldValue("SoundEngineerSongMixingExperience");
    var soundEngineerAudioDescriptionMixingExperienceFieldValue = this.getFieldValue("SoundEngineerAudioDescriptionMixingExperience");
    var soundEngineerRemoteRecordingCapabilityFieldValue = this.getFieldValue("SoundEngineerRemoteRecordingCapability");
    var soundEngineerDubbingExperienceFieldValue = this.getFieldValue("SoundEngineerDubbingExperience");
    var soundEngineerVoiceOverExperienceFieldValue = this.getFieldValue("SoundEngineerVoiceOverExperience");
    var soundEngineerSongsExperienceFieldValue = this.getFieldValue("SoundEngineerSongsExperience");
    var soundEngineerProToolsExperienceFieldValue = this.getFieldValue("SoundEngineerProToolsExperience");
    var soundEngineerDolby51ExperienceFieldValue = this.getFieldValue("SoundEngineerDolby51Experience");
    var soundEngineerAtmosExperienceFieldValue = this.getFieldValue("SoundEngineerAtmosExperience");
    var soundEngineerFoleyExperienceFieldValue = this.getFieldValue("SoundEngineerFoleyExperience");
    var soundEngineerSchoolsFieldValue = this.getFieldValue("SoundEngineerSchools");
    var soundEngineerStudiosFieldValue = this.getFieldValue("SoundEngineerStudios");
    var soundEngineerClientsFieldValue = this.getFieldValue("SoundEngineerClients");
    var soundEngineerDoNotUseFieldValue = this.getFieldValue("SoundEngineerDoNotUse");


    //personal
    if(skillLevelFieldValue){
        let skillLevelFieldValueArr = skillLevelFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<skillLevelFieldValueArr.length;i++){
          newArr.push(parseInt(skillLevelFieldValueArr[i]));
        }
        items.push({"SearchProperty": 22,"Values": newArr});
    }
    if(skillTypeFieldValue){
        let skillTypeFieldValueArr = skillTypeFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<skillTypeFieldValueArr.length;i++){
          newArr.push(parseInt(skillTypeFieldValueArr[i]));
        }
        if(this.props.profileType == "VoiceActor"){
          //newArr.push(parseInt(3010,3020));
        }
        items.push({"SearchProperty": 20,"Values": newArr});
    }
    if(nativeLanguageFieldValue){
        items.push({"SearchProperty": 9,"Values": [parseInt(nativeLanguageFieldValue)]});
    }
    if(additionalLanguageFieldValue){
        let additionalLanguageFieldValueArr = additionalLanguageFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<additionalLanguageFieldValueArr.length;i++){
          newArr.push(parseInt(additionalLanguageFieldValueArr[i]));
        }
        items.push({"SearchProperty": 10,"Values": newArr});
    }
    if(countryofLivingFieldValue){
        let countryofLivingFieldValueArr = countryofLivingFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<countryofLivingFieldValueArr.length;i++){
          newArr.push(parseInt(countryofLivingFieldValueArr[i]));
        }
        items.push({"SearchProperty": 6,"Values": newArr});
    }
    if(cityFieldValue){
        let cityFieldValueArr = cityFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<cityFieldValueArr.length;i++){
          newArr.push(parseInt(cityFieldValueArr[i]));
        }
        items.push({"SearchProperty": 7,"Values": newArr});
    }
    if(regionFieldValue){
         let regionFieldValueArr = regionFieldValue.split(",");
         let newArr=[];
         for(let i=0;i<regionFieldValueArr.length;i++){
           newArr.push(parseInt(regionFieldValueArr[i]));
         }
         items.push({"SearchProperty": 16,"Values": newArr});
     }
     if(ethnicityFieldValue){
         let ethnicityFieldValueArr = ethnicityFieldValue.split(",");
         let newArr=[];
         for(let i=0;i<ethnicityFieldValueArr.length;i++){
           newArr.push(parseInt(ethnicityFieldValueArr[i]));
         }
         items.push({"SearchProperty": 13,"Values": newArr});
     }
     if(identityFieldValue){
         let identityFieldValueArr = identityFieldValue.split(",");
         let newArr=[];
         for(let i=0;i<identityFieldValueArr.length;i++){
           newArr.push(parseInt(identityFieldValueArr[i]));
         }
         items.push({"SearchProperty": 14,"Values": newArr});
     }
     if(ageFromFieldValue || ageToFieldValue){
       if(ageFromFieldValue && ageToFieldValue == '' || ageFromFieldValue && ageToFieldValue == null){
           let ageArr = [];
           for (let step = ageFromFieldValue; step < 101; step++) {
             ageArr.push(parseInt(step));
           }
           items.push({"SearchProperty": 3,"Values": ageArr});
       }
       if(ageFromFieldValue == '' && ageToFieldValue || ageFromFieldValue == null && ageToFieldValue){
           let number = ageToFieldValue;
           let ageArr = [];
           for (let step = 1; step <= number; step++) {
             ageArr.push(parseInt(step));
           }
           items.push({"SearchProperty": 3,"Values": ageArr});
       }
       if(ageFromFieldValue && ageToFieldValue){
           if(parseInt(ageFromFieldValue)>parseInt(ageToFieldValue)){
             //here should be message - age from bigger than age to
           }else{
             let ageArr = [];
             let numberFrom = parseInt(ageFromFieldValue);
             let numberTo = parseInt(ageToFieldValue);

             while (numberFrom <= numberTo) {
                 ageArr.push(numberFrom);
                 numberFrom++;
             }
             items.push({"SearchProperty": 3,"Values": ageArr});
           }
         }
       }
   // if(skillVendorStatusFieldValue){
   //       items.push({"SearchProperty": 5,"Values": [parseInt(0)]});
   // }
   // if(skillVendorStatusFieldValue == false){
   //       items.push({"SearchProperty": 5,"Values": [parseInt(10)]});
   // }
   if(doNotUseFieldValue){
       items.push({"SearchProperty": 4,"Values": [parseInt(1)]});
   }
   if(knownTalentFieldValue){
       items.push({"SearchProperty": 24,"Values": [parseInt(1)]});
   }

   if(editorSchoolsFieldValue){
     if (typeof editorSchoolsFieldValue === 'string' || editorSchoolsFieldValue instanceof String){
        items.push({"SearchProperty": 2317,"Values": [parseInt(editorSchoolsFieldValue)]});
     }
     if( editorSchoolsFieldValue instanceof Array && editorSchoolsFieldValue.length > 0){
       if(typeof editorSchoolsFieldValue[0] === 'object' && editorSchoolsFieldValue.length === 1){
         let obj = editorSchoolsFieldValue[0];
         items.push({"SearchProperty": 2317,"Values": [obj.value]});
       }
       if(typeof editorSchoolsFieldValue[0] === 'object' && editorSchoolsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<editorSchoolsFieldValue.length;i++){
           newArr.push(editorSchoolsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2317,"Values": newArr});
       }
     }
   }

  if(singerSchoolsFieldValue){
    if (typeof singerSchoolsFieldValue === 'string' || singerSchoolsFieldValue instanceof String){
       items.push({"SearchProperty": 2515,"Values": [parseInt(singerSchoolsFieldValue)]});
    }
    if( singerSchoolsFieldValue instanceof Array && singerSchoolsFieldValue.length > 0){
      if(typeof singerSchoolsFieldValue[0] === 'object' && singerSchoolsFieldValue.length === 1){
        let obj = singerSchoolsFieldValue[0];
        items.push({"SearchProperty": 2515,"Values": [obj.value]});
      }
      if(typeof singerSchoolsFieldValue[0] === 'object' && singerSchoolsFieldValue.length > 1){
        let newArr=[];
        for(let i=0;i<singerSchoolsFieldValue.length;i++){
          newArr.push(singerSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2515,"Values": newArr});
      }
    }
  }

  if(soundEngineerSchoolsFieldValue){
    if (typeof soundEngineerSchoolsFieldValue === 'string' || soundEngineerSchoolsFieldValue instanceof String){
       items.push({"SearchProperty": 2616,"Values": [parseInt(soundEngineerSchoolsFieldValue)]});
    }
    if( soundEngineerSchoolsFieldValue instanceof Array && soundEngineerSchoolsFieldValue.length > 0){
      if(typeof soundEngineerSchoolsFieldValue[0] === 'object' && soundEngineerSchoolsFieldValue.length === 1){
        let obj = soundEngineerSchoolsFieldValue[0];
        items.push({"SearchProperty": 2616,"Values": [obj.value]});
      }
      if(typeof soundEngineerSchoolsFieldValue[0] === 'object' && soundEngineerSchoolsFieldValue.length > 1){
        let newArr=[];
        for(let i=0;i<soundEngineerSchoolsFieldValue.length;i++){
          newArr.push(soundEngineerSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2616,"Values": newArr});
      }
    }
  }

  if(voiceActorSchoolsFieldValue){
    if (typeof voiceActorSchoolsFieldValue === 'string' || voiceActorSchoolsFieldValue instanceof String){
       items.push({"SearchProperty": 2826,"Values": [parseInt(voiceActorSchoolsFieldValue)]});
    }
    if( voiceActorSchoolsFieldValue instanceof Array && voiceActorSchoolsFieldValue.length > 0){
      if(typeof voiceActorSchoolsFieldValue[0] === 'object' && voiceActorSchoolsFieldValue.length === 1){
        let obj = voiceActorSchoolsFieldValue[0];
        items.push({"SearchProperty": 2826,"Values": [obj.value]});
      }
      if(typeof voiceActorSchoolsFieldValue[0] === 'object' && voiceActorSchoolsFieldValue.length > 1){
        let newArr=[];
        for(let i=0;i<voiceActorSchoolsFieldValue.length;i++){
          newArr.push(voiceActorSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2826,"Values": newArr});
      }
    }
  }



   //actor
   if(voiceActorDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2801,"Values": [parseInt(1)]});
   }
   if(voiceActorAudiobooksExperienceFieldValue){
     items.push({"SearchProperty": 2802,"Values": [parseInt(1)]});
   }
   if(voiceActorVoiceOverExperienceFieldValue){
     items.push({"SearchProperty": 2803,"Values": [parseInt(1)]});
   }
   if(voiceActorRadioExperienceFieldValue){
     items.push({"SearchProperty": 2804,"Values": [parseInt(1)]});
   }
   if(voiceActorTheatreActorExperienceFieldValue){
     items.push({"SearchProperty": 2805,"Values": [parseInt(1)]});
   }
   if(voiceActorMovieActorExperienceFieldValue){
     items.push({"SearchProperty": 2806,"Values": [parseInt(1)]});
   }
   if(voiceActorAudioDescriptionExperienceFieldValue){
     items.push({"SearchProperty": 2807,"Values": [parseInt(1)]});
   }
   if(voiceActorTheatricalExperienceFieldValue){
     items.push({"SearchProperty": 2808,"Values": [parseInt(1)]});
   }
   if(voiceActorTVExperienceFieldValue){
     items.push({"SearchProperty": 2809,"Values": [parseInt(1)]});
   }
   if(voiceActorGamesExperienceFieldValue){
     items.push({"SearchProperty": 2810,"Values": [parseInt(1)]});
   }
   if(voiceActorPromoOrCommercialsExperienceFieldValue){
     items.push({"SearchProperty": 2811,"Values": [parseInt(1)]});
   }
   if(voiceActorLiveActionExperienceFieldValue){
     items.push({"SearchProperty": 2812,"Values": [parseInt(1)]});
   }
   if(voiceActorAnimationExperienceFieldValue){
     items.push({"SearchProperty": 2813,"Values": [parseInt(1)]});
   }
   if(voiceActorRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2814,"Values": [parseInt(voiceActorRemoteRecordingCapabilityFieldValue)]});
   }
   if(voiceActorLiveActionMaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2815,"Values": [parseInt(1)]});
   }
   if(voiceActorLiveActionFemaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2816,"Values": [parseInt(1)]});
   }
   if(voiceActorAnimationMaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2817,"Values": [parseInt(1)]});
   }
   if(voiceActorAnimationFemaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2818,"Values": [parseInt(1)]});
   }
   if(voiceActorGenderNeutralVoiceFieldValue){
     items.push({"SearchProperty": 2825,"Values": [parseInt(1)]});
   }
   if(voiceActorStudiosFieldValue){
     if (typeof voiceActorStudiosFieldValue === 'string' || voiceActorStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2819,"Values": [parseInt(voiceActorStudiosFieldValue)]});
     }
     if( voiceActorStudiosFieldValue instanceof Array && voiceActorStudiosFieldValue.length > 0){
       if(typeof voiceActorStudiosFieldValue[0] === 'object' && voiceActorStudiosFieldValue.length === 1){
         let obj = voiceActorStudiosFieldValue[0];
         items.push({"SearchProperty": 2819,"Values": [obj.value]});
       }
       if(typeof voiceActorStudiosFieldValue[0] === 'object' && voiceActorStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<voiceActorStudiosFieldValue.length;i++){
           newArr.push(voiceActorStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2819,"Values": newArr});
       }
     }
   }

   if(voiceActorClientsFieldValue){
     if (typeof voiceActorClientsFieldValue === 'string' || voiceActorClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2820,"Values": [parseInt(voiceActorClientsFieldValue)]});
     }
     if( voiceActorClientsFieldValue instanceof Array && voiceActorClientsFieldValue.length > 0){
       if(typeof voiceActorClientsFieldValue[0] === 'object' && voiceActorClientsFieldValue.length === 1){
         let obj = voiceActorClientsFieldValue[0];
         items.push({"SearchProperty": 2820,"Values": [obj.value]});
       }
       if(typeof voiceActorClientsFieldValue[0] === 'object' && voiceActorClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<voiceActorClientsFieldValue.length;i++){
           newArr.push(voiceActorClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2820,"Values": newArr});
       }
     }
   }
   if(voiceActorDoNotUseFieldValue){
     items.push({"SearchProperty": 2827,"Values": [parseInt(1)]});
   }
   if(voiceActorVoiceAgeRangeFieldValue){
     let voiceActorVoiceAgeRangeFieldValueArr = voiceActorVoiceAgeRangeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<voiceActorVoiceAgeRangeFieldValueArr.length;i++){
       newArr.push(parseInt(voiceActorVoiceAgeRangeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2821,"Values": newArr});
   }
   if(productionFieldValue){
     if (typeof productionFieldValue === 'string' || productionFieldValue instanceof String){
        items.push({"SearchProperty": 17,"Values": [parseInt(productionFieldValue)]});
     }
     if( productionFieldValue instanceof Array && productionFieldValue.length > 0){
       if(typeof productionFieldValue[0] === 'object' && productionFieldValue.length === 1){
         let obj = productionFieldValue[0];
         items.push({"SearchProperty": 17,"Values": [obj.value]});
       }
       if(typeof vacancyFieldValue[0] === 'object' && productionFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<productionFieldValue.length;i++){
           newArr.push(productionFieldValue[i].value);
         }
         items.push({"SearchProperty": 17,"Values": newArr});
       }
     }
   }
   if(vacancyFieldValue){
     if (typeof vacancyFieldValue === 'string' || vacancyFieldValue instanceof String){
        items.push({"SearchProperty": 18,"Values": [parseInt(vacancyFieldValue)]});
     }
     if( vacancyFieldValue instanceof Array && vacancyFieldValue.length > 0){
       if(typeof vacancyFieldValue[0] === 'object' && vacancyFieldValue.length === 1){
         let obj = vacancyFieldValue[0];
         items.push({"SearchProperty": 18,"Values": [obj.value]});
       }
       if(typeof vacancyFieldValue[0] === 'object' && vacancyFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<vacancyFieldValue.length;i++){
           newArr.push(vacancyFieldValue[i].value);
         }
         items.push({"SearchProperty": 18,"Values": newArr});
       }
     }
   }
   if(externalExperienceFieldValue){
     if (typeof externalExperienceFieldValue === 'string' || externalExperienceFieldValue instanceof String){
        items.push({"SearchProperty": 19,"Values": [parseInt(externalExperienceFieldValue)]});
     }
     if( externalExperienceFieldValue instanceof Array && externalExperienceFieldValue.length > 0){
       if(typeof externalExperienceFieldValue[0] === 'object' && externalExperienceFieldValue.length === 1){
         let obj = externalExperienceFieldValue[0];
         items.push({"SearchProperty": 19,"Values": [obj.value]});
       }
       if(typeof externalExperienceFieldValue[0] === 'object' && externalExperienceFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<externalExperienceFieldValue.length;i++){
           newArr.push(externalExperienceFieldValue[i].value);
         }
         items.push({"SearchProperty": 19,"Values": newArr});
       }
     }
   }
   if(voiceActorVoiceTypeFieldValue){
     let voiceActorVoiceTypeFieldValueArr = voiceActorVoiceTypeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<voiceActorVoiceTypeFieldValueArr.length;i++){
       newArr.push(parseInt(voiceActorVoiceTypeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2823,"Values": newArr});
   }
   if(voiceActorLanguageAccentFieldValue){
     let voiceActorLanguageAccentFieldValueArr = voiceActorLanguageAccentFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<voiceActorLanguageAccentFieldValueArr.length;i++){
       newArr.push(parseInt(voiceActorLanguageAccentFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2822,"Values": newArr});
   }
   if(voiceActorUnionFieldValue){
     let voiceActorUnionFieldValueArr = voiceActorUnionFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<voiceActorUnionFieldValueArr.length;i++){
       newArr.push(parseInt(voiceActorUnionFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2824,"Values": newArr});
   }
   if(bookerStudiosFieldValue){
     if (typeof bookerStudiosFieldValue === 'string' || bookerStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2104,"Values": [parseInt(bookerStudiosFieldValue)]});
     }
     if( bookerStudiosFieldValue instanceof Array && bookerStudiosFieldValue.length > 0){
       if(typeof bookerStudiosFieldValue[0] === 'object' && bookerStudiosFieldValue.length === 1){
         let obj = bookerStudiosFieldValue[0];
         items.push({"SearchProperty": 2104,"Values": [obj.value]});
       }
       if(typeof bookerStudiosFieldValue[0] === 'object' && bookerStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<bookerStudiosFieldValue.length;i++){
           newArr.push(bookerStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2104,"Values": newArr});
       }
     }
   }

   if(bookerTheatricalExperienceFieldValue){
     items.push({"SearchProperty": 2101,"Values": [parseInt(1)]});
   }
   if(bookerTVExperienceFieldValue){
     items.push({"SearchProperty": 2102,"Values": [parseInt(1)]});
   }
   if(bookerInteractiveExperienceFieldValue){
     items.push({"SearchProperty": 2103,"Values": [parseInt(1)]});
   }
   if(bookerDoNotUseFieldValue){
     items.push({"SearchProperty": 2107,"Values": [parseInt(1)]});
   }

   if(singerDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2501,"Values": [parseInt(1)]});
   }
   if(singerStageExperienceFieldValue){
     items.push({"SearchProperty": 2502,"Values": [parseInt(1)]});
   }
   if(singerTheatreExperienceFieldValue){
     items.push({"SearchProperty": 2503,"Values": [parseInt(1)]});
   }
   if(singerTalentShowExperienceFieldValue){
     items.push({"SearchProperty": 2505,"Values": [parseInt(1)]});
   }
   if(singerMaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2509,"Values": [parseInt(1)]});
   }
   if(singerFemaleVoiceGenderFieldValue){
     items.push({"SearchProperty": 2510,"Values": [parseInt(1)]});
   }
   if(singerGenderNeutralVoiceFieldValue){
     items.push({"SearchProperty": 2514,"Values": [parseInt(1)]});
   }
   if(singerVocalRangeFieldValue){
     let singerVocalRangeFieldValueArr = singerVocalRangeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<singerVocalRangeFieldValueArr.length;i++){
       newArr.push(parseInt(singerVocalRangeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2506,"Values": newArr});
   }
   if(singerMusicNotesReadingLevelFieldValue){
     let singerMusicNotesReadingLevelFieldValueArr = singerMusicNotesReadingLevelFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<singerMusicNotesReadingLevelFieldValueArr.length;i++){
       newArr.push(parseInt(singerMusicNotesReadingLevelFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2507,"Values": newArr});
   }
   if(singerVoiceAgeRangeFieldValue){
     let singerVoiceAgeRangeFieldValueArr = singerVoiceAgeRangeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<singerVoiceAgeRangeFieldValueArr.length;i++){
       newArr.push(parseInt(singerVoiceAgeRangeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2508,"Values": newArr});
   }
   if(singerStudiosFieldValue){
     if (typeof singerStudiosFieldValue === 'string' || singerStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2511,"Values": [parseInt(singerStudiosFieldValue)]});
     }
     if( singerStudiosFieldValue instanceof Array && singerStudiosFieldValue.length > 0){
       if(typeof singerStudiosFieldValue[0] === 'object' && singerStudiosFieldValue.length === 1){
         let obj = singerStudiosFieldValue[0];
         items.push({"SearchProperty": 2511,"Values": [obj.value]});
       }
       if(typeof singerStudiosFieldValue[0] === 'object' && singerStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<singerStudiosFieldValue.length;i++){
           newArr.push(singerStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2511,"Values": newArr});
       }
     }
   }
   if(singerClientsFieldValue){
     if (typeof singerClientsFieldValue === 'string' || singerClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2512,"Values": [parseInt(singerClientsFieldValue)]});
     }
     if( singerClientsFieldValue instanceof Array && singerClientsFieldValue.length > 0){
       if(typeof singerClientsFieldValue[0] === 'object' && singerClientsFieldValue.length === 1){
         let obj = singerClientsFieldValue[0];
         items.push({"SearchProperty": 2512,"Values": [obj.value]});
       }
       if(typeof singerClientsFieldValue[0] === 'object' && singerClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<singerClientsFieldValue.length;i++){
           newArr.push(singerClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2512,"Values": newArr});
       }
     }
   }

   if(singerRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2504,"Values": [parseInt(singerRemoteRecordingCapabilityFieldValue)]});
   }
   if(singerUnionFieldValue){
     let singerUnionFieldValueArr = singerUnionFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<singerUnionFieldValueArr.length;i++){
       newArr.push(parseInt(singerUnionFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2513,"Values": newArr});
   }
   if(singerDoNotUseFieldValue){
     items.push({"SearchProperty": 2516,"Values": [parseInt(1)]});
   }

   if(directorDubbingDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2201,"Values": [parseInt(1)]});
   }
   if(directorVoiceOverDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2202,"Values": [parseInt(1)]});
   }
   if(directorSongDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2203,"Values": [parseInt(1)]});
   }
   if(directorDubbingActorExperienceFieldValue){
     items.push({"SearchProperty": 2204,"Values": [parseInt(1)]});
   }
   if(directorStageDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2205,"Values": [parseInt(1)]});
   }
   if(directorMovieDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2206,"Values": [parseInt(1)]});
   }
   if(directorTheatricalExperienceFieldValue){
     items.push({"SearchProperty": 2207,"Values": [parseInt(1)]});
   }
   if(directorTVExperienceFieldValue){
     items.push({"SearchProperty": 2208,"Values": [parseInt(1)]});
   }
   if(directorGamesExperienceFieldValue){
     items.push({"SearchProperty": 2209,"Values": [parseInt(1)]});
   }
   if(directorPromoOrCommercialsExperienceFieldValue){
     items.push({"SearchProperty": 2210,"Values": [parseInt(1)]});
   }
   if(directorLiveActionExperienceFieldValue){
     items.push({"SearchProperty": 2211,"Values": [parseInt(1)]});
   }
   if(directorAnimationExperienceFieldValue){
     items.push({"SearchProperty": 2212,"Values": [parseInt(1)]});
   }
   if(directorAudioDescriptionExperienceFieldValue){
     items.push({"SearchProperty": 2213,"Values": [parseInt(1)]});
   }
   if(directorRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2214,"Values": [parseInt(directorRemoteRecordingCapabilityFieldValue)]});
   }
   if(directorAppAccessRevokedFieldValue === 0){
     items.push({"SearchProperty": 2215,"Values": [parseInt(0)]});
   }
   if(directorAppAccessRevokedFieldValue){
     items.push({"SearchProperty": 2215,"Values": [parseInt(1)]});
   }
   if(directorStudiosFieldValue){
     if (typeof directorStudiosFieldValue === 'string' || directorStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2216,"Values": [parseInt(directorStudiosFieldValue)]});
     }
     if( directorStudiosFieldValue instanceof Array && directorStudiosFieldValue.length > 0){
       if(typeof directorStudiosFieldValue[0] === 'object' && directorStudiosFieldValue.length === 1){
         let obj = directorStudiosFieldValue[0];
         items.push({"SearchProperty": 2216,"Values": [obj.value]});
       }
       if(typeof directorStudiosFieldValue[0] === 'object' && directorStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<singerStudiosFieldValue.length;i++){
           newArr.push(singerStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2216,"Values": newArr});
       }
     }
   }
   if(directorClientsFieldValue){
     if (typeof directorClientsFieldValue === 'string' || directorClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2217,"Values": [parseInt(directorClientsFieldValue)]});
     }
     if( directorClientsFieldValue instanceof Array && directorClientsFieldValue.length > 0){
       if(typeof directorClientsFieldValue[0] === 'object' && directorClientsFieldValue.length === 1){
         let obj = directorClientsFieldValue[0];
         items.push({"SearchProperty": 2217,"Values": [obj.value]});
       }
       if(typeof directorClientsFieldValue[0] === 'object' && directorClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<directorClientsFieldValue.length;i++){
           newArr.push(directorClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2217,"Values": newArr});
       }
     }
   }

   if(directorSchoolsFieldValue){
     if (typeof directorSchoolsFieldValue === 'string' || directorSchoolsFieldValue instanceof String){
        items.push({"SearchProperty": 2218,"Values": [parseInt(directorSchoolsFieldValue)]});
     }
     if( directorSchoolsFieldValue instanceof Array && directorSchoolsFieldValue.length > 0){
       if(typeof directorSchoolsFieldValue[0] === 'object' && directorSchoolsFieldValue.length === 1){
         let obj = directorSchoolsFieldValue[0];
         items.push({"SearchProperty": 2218,"Values": [obj.value]});
       }
       if(typeof directorSchoolsFieldValue[0] === 'object' && directorSchoolsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<directorSchoolsFieldValue.length;i++){
           newArr.push(directorSchoolsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2218,"Values": newArr});
       }
     }
   }
   if(directorDoNotUseFieldValue){
     items.push({"SearchProperty": 2219,"Values": [parseInt(1)]});
   }


   if(lyricistExperienceFieldValue){
     items.push({"SearchProperty": 2401,"Values": [parseInt(1)]});
   }
   if(lyricistDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2402,"Values": [parseInt(1)]});
   }
   if(lyricistMusicianExperienceFieldValue){
     items.push({"SearchProperty": 2403,"Values": [parseInt(1)]});
   }
   if(lyricistNumberOfSongsWrittenFieldValue){
     let lyricistNumberOfSongsWrittenFieldValueArr = lyricistNumberOfSongsWrittenFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<lyricistNumberOfSongsWrittenFieldValueArr.length;i++){
       newArr.push(parseInt(lyricistNumberOfSongsWrittenFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2404,"Values": newArr});
   }
   if(lyricistRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2405,"Values": [parseInt(lyricistRemoteRecordingCapabilityFieldValue)]});
   }
   if(lyricistMusicalExperienceFieldValue){
     items.push({"SearchProperty": 2406,"Values": [parseInt(1)]});
   }
   if(lyricistTheatreExperienceFieldValue){
     items.push({"SearchProperty": 2407,"Values": [parseInt(1)]});
   }
   if(lyricistPromoOrCommercialsExperienceFieldValue){
     items.push({"SearchProperty": 2408,"Values": [parseInt(1)]});
   }
   if(lyricistUniversityDegreeFieldValue){
     let lyricistUniversityDegreeFieldValueArr = lyricistUniversityDegreeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<lyricistUniversityDegreeFieldValueArr.length;i++){
       newArr.push(parseInt(lyricistUniversityDegreeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2409,"Values": newArr});
   }
   if(lyricistStudiosFieldValue){
     if (typeof lyricistStudiosFieldValue === 'string' || lyricistStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2410,"Values": [parseInt(lyricistStudiosFieldValue)]});
     }
     if( lyricistStudiosFieldValue instanceof Array && lyricistStudiosFieldValue.length > 0){
       if(typeof lyricistStudiosFieldValue[0] === 'object' && lyricistStudiosFieldValue.length === 1){
         let obj = lyricistStudiosFieldValue[0];
         items.push({"SearchProperty": 2410,"Values": [obj.value]});
       }
       if(typeof lyricistStudiosFieldValue[0] === 'object' && lyricistStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<lyricistStudiosFieldValue.length;i++){
           newArr.push(lyricistStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2410,"Values": newArr});
       }
     }
   }
   if(lyricistClientsFieldValue){
     if (typeof lyricistClientsFieldValue === 'string' || lyricistClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2411,"Values": [parseInt(lyricistClientsFieldValue)]});
     }
     if( lyricistClientsFieldValue instanceof Array && lyricistClientsFieldValue.length > 0){
       if(typeof lyricistClientsFieldValue[0] === 'object' && lyricistClientsFieldValue.length === 1){
         let obj = lyricistClientsFieldValue[0];
         items.push({"SearchProperty": 2411,"Values": [obj.value]});
       }
       if(typeof lyricistClientsFieldValue[0] === 'object' && lyricistClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<lyricistClientsFieldValue.length;i++){
           newArr.push(lyricistClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2411,"Values": newArr});
       }
     }
   }
   if(lyricistDoNotUseFieldValue){
     items.push({"SearchProperty": 2413,"Values": [parseInt(1)]});
   }


   if(translatorSubtitlesExperienceFieldValue){
     items.push({"SearchProperty": 2701,"Values": [parseInt(1)]});
   }
   if(translatorDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2702,"Values": [parseInt(1)]});
   }
   if(translatorVoiceOverExperienceFieldValue){
     items.push({"SearchProperty": 2703,"Values": [parseInt(1)]});
   }
   if(translatorGamingExperienceFieldValue){
     items.push({"SearchProperty": 2704,"Values": [parseInt(1)]});
   }
   if(translatorAudioDescriptionExperienceFieldValue){
     items.push({"SearchProperty": 2705,"Values": [parseInt(1)]});
   }
   if(translatorHOHSDHCCEExperienceFieldValue){
     items.push({"SearchProperty": 2706,"Values": [parseInt(1)]});
   }
   if(translatorNumberOfTranslationsFieldValue){
     let translatorNumberOfTranslationsFieldValueArr = translatorNumberOfTranslationsFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<translatorNumberOfTranslationsFieldValueArr.length;i++){
       newArr.push(parseInt(translatorNumberOfTranslationsFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2708,"Values": newArr});
   }
   if(translatorTheatricalExperienceFieldValue){
     items.push({"SearchProperty": 2709,"Values": [parseInt(1)]});
   }
   if(translatorTVExperienceFieldValue){
     items.push({"SearchProperty": 2710,"Values": [parseInt(1)]});
   }
   if(translatorGamesExperienceFieldValue){
     items.push({"SearchProperty": 2711,"Values": [parseInt(1)]});
   }
   if(translatorPromoOrCommercialsExperienceFieldValue){
     items.push({"SearchProperty": 2712,"Values": [parseInt(1)]});
   }
   if(translatorLiveActionExperienceFieldValue){
     items.push({"SearchProperty": 2713,"Values": [parseInt(1)]});
   }
   if(translatorAnimationExperienceFieldValue){
     items.push({"SearchProperty": 2714,"Values": [parseInt(1)]});
   }
   if(translatorUniversityDegreeFieldValue){
     let translatorUniversityDegreeFieldValueArr = translatorUniversityDegreeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<translatorUniversityDegreeFieldValueArr.length;i++){
       newArr.push(parseInt(translatorUniversityDegreeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2715,"Values": newArr});
   }
   if(translatorStudiosFieldValue){
     if (typeof translatorStudiosFieldValue === 'string' || translatorStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2716,"Values": [parseInt(translatorStudiosFieldValue)]});
     }
     if( translatorStudiosFieldValue instanceof Array && translatorStudiosFieldValue.length > 0){
       if(typeof translatorStudiosFieldValue[0] === 'object' && translatorStudiosFieldValue.length === 1){
         let obj = translatorStudiosFieldValue[0];
         items.push({"SearchProperty": 2716,"Values": [obj.value]});
       }
       if(typeof translatorStudiosFieldValue[0] === 'object' && translatorStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<translatorStudiosFieldValue.length;i++){
           newArr.push(translatorStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2716,"Values": newArr});
       }
     }
   }

   if(translatorClientsFieldValue){
     if (typeof translatorClientsFieldValue === 'string' || translatorClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2717,"Values": [parseInt(translatorClientsFieldValue)]});
     }
     if( translatorClientsFieldValue instanceof Array && translatorClientsFieldValue.length > 0){
       if(typeof translatorClientsFieldValue[0] === 'object' && translatorClientsFieldValue.length === 1){
         let obj = translatorClientsFieldValue[0];
         items.push({"SearchProperty": 2717,"Values": [obj.value]});
       }
       if(typeof translatorClientsFieldValue[0] === 'object' && translatorClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<translatorClientsFieldValue.length;i++){
           newArr.push(translatorClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2717,"Values": newArr});
       }
     }
   }
   if(translatorDoNotUseFieldValue){
     items.push({"SearchProperty": 2719,"Values": [parseInt(1)]});
   }


   if(editorRecordingEditingExperienceFieldValue){
     items.push({"SearchProperty": 2301,"Values": [parseInt(1)]});
   }
   if(editorDialogueEditingExperienceFieldValue){
     items.push({"SearchProperty": 2302,"Values": [parseInt(1)]});
   }
   if(editorMusicAndEffectsExperienceFieldValue){
     items.push({"SearchProperty": 2303,"Values": [parseInt(1)]});
   }
   if(editorMixEditingExperienceFieldValue){
     items.push({"SearchProperty": 2304,"Values": [parseInt(1)]});
   }
   if(editorPreparingTakesExperienceFieldValue){
     items.push({"SearchProperty": 2305,"Values": [parseInt(1)]});
   }
   if(editorDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2306,"Values": [parseInt(1)]});
   }
   if(editorVoiceOverExperienceFieldValue){
     items.push({"SearchProperty": 2307,"Values": [parseInt(1)]});
   }
   if(editorSongsExperienceFieldValue){
     items.push({"SearchProperty": 2308,"Values": [parseInt(1)]});
   }
   if(editorProToolsExperienceFieldValue){
     items.push({"SearchProperty": 2309,"Values": [parseInt(1)]});
   }
   if(editorDolby51ExperienceFieldValue){
     items.push({"SearchProperty": 2310,"Values": [parseInt(1)]});
   }
   if(editorAtmosExperienceFieldValue){
     items.push({"SearchProperty": 2311,"Values": [parseInt(1)]});
   }
   if(editorFoleyExperienceFieldValue){
     items.push({"SearchProperty": 2312,"Values": [parseInt(1)]});
   }
   if(editorAudioDescriptionExperienceFieldValue){
     items.push({"SearchProperty": 2313,"Values": [parseInt(1)]});
   }
   if(editorStudiosFieldValue){
     if (typeof editorStudiosFieldValue === 'string' || editorStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2315,"Values": [parseInt(editorStudiosFieldValue)]});
     }
     if( editorStudiosFieldValue instanceof Array && editorStudiosFieldValue.length > 0){
       if(typeof editorStudiosFieldValue[0] === 'object' && editorStudiosFieldValue.length === 1){
         let obj = editorStudiosFieldValue[0];
         items.push({"SearchProperty": 2315,"Values": [obj.value]});
       }
       if(typeof editorStudiosFieldValue[0] === 'object' && editorStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<editorStudiosFieldValue.length;i++){
           newArr.push(editorStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2315,"Values": newArr});
       }
     }
   }

   if(editorClientsFieldValue){
     if (typeof editorClientsFieldValue === 'string' || editorClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2316,"Values": [parseInt(editorClientsFieldValue)]});
     }
     if( editorClientsFieldValue instanceof Array && editorClientsFieldValue.length > 0){
       if(typeof editorClientsFieldValue[0] === 'object' && editorClientsFieldValue.length === 1){
         let obj = editorClientsFieldValue[0];
         items.push({"SearchProperty": 2316,"Values": [obj.value]});
       }
       if(typeof editorClientsFieldValue[0] === 'object' && editorClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<editorClientsFieldValue.length;i++){
           newArr.push(editorClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2316,"Values": newArr});
       }
     }
   }

   if(editorRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2314,"Values": [parseInt(editorRemoteRecordingCapabilityFieldValue)]});
   }

   if(editorDoNotUseFieldValue){
     items.push({"SearchProperty": 2318,"Values": [parseInt(1)]});
   }

   if(adaptorAdaptorExperienceFieldValue){
     items.push({"SearchProperty": 2001,"Values": [parseInt(1)]});
   }
   if(adaptorDubbingDirectorExperienceFieldValue){
     items.push({"SearchProperty": 2002,"Values": [parseInt(1)]});
   }
   if(adaptorTranslatorExperienceFieldValue){
     items.push({"SearchProperty": 2003,"Values": [parseInt(1)]});
   }
   if(adaptorVoiceActorExperienceFieldValue){
     items.push({"SearchProperty": 2004,"Values": [parseInt(1)]});
   }
   if(adaptorTheatricalExperienceFieldValue){
     items.push({"SearchProperty": 2005,"Values": [parseInt(1)]});
   }
   if(adaptorTVExperienceFieldValue){
     items.push({"SearchProperty": 2006,"Values": [parseInt(1)]});
   }
   if(adaptorGamesExperienceFieldValue){
     items.push({"SearchProperty": 2007,"Values": [parseInt(1)]});
   }
   if(adaptorPromoOrCommercialsExperienceFieldValue){
     items.push({"SearchProperty": 2008,"Values": [parseInt(1)]});
   }
   if(adaptorLiveActionExperienceFieldValue){
     items.push({"SearchProperty": 2009,"Values": [parseInt(1)]});
   }
   if(adaptorAnimationExperienceFieldValue){
     items.push({"SearchProperty": 2010,"Values": [parseInt(1)]});
   }
   if(adaptorAudioDescriptionExperienceFieldValue){
     items.push({"SearchProperty": 2011,"Values": [parseInt(1)]});
   }
   if(adaptorNumberOfAdaptionsFieldValue){
     let adaptorNumberOfAdaptionsFieldValueArr = adaptorNumberOfAdaptionsFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<adaptorNumberOfAdaptionsFieldValueArr.length;i++){
       newArr.push(parseInt(adaptorNumberOfAdaptionsFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2012,"Values": newArr});
   }
   if(adaptorUniversityDegreeFieldValue){
     let adaptorUniversityDegreeFieldValueArr = adaptorUniversityDegreeFieldValue.split(",");
     let newArr=[];
     for(let i=0;i<adaptorUniversityDegreeFieldValueArr.length;i++){
       newArr.push(parseInt(adaptorUniversityDegreeFieldValueArr[i]));
     }
     items.push({"SearchProperty": 2013,"Values": newArr});
   }
   if(adaptorStudiosFieldValue){
     if (typeof adaptorStudiosFieldValue === 'string' || adaptorStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2014,"Values": [parseInt(adaptorStudiosFieldValue)]});
     }
     if( adaptorStudiosFieldValue instanceof Array && adaptorStudiosFieldValue.length > 0){
       if(typeof adaptorStudiosFieldValue[0] === 'object' && adaptorStudiosFieldValue.length === 1){
         let obj = adaptorStudiosFieldValue[0];
         items.push({"SearchProperty": 2014,"Values": [obj.value]});
       }
       if(typeof adaptorStudiosFieldValue[0] === 'object' && adaptorStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<adaptorStudiosFieldValue.length;i++){
           newArr.push(adaptorStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2014,"Values": newArr});
       }
     }
   }

   if(adaptorClientsFieldValue){
     if (typeof adaptorClientsFieldValue === 'string' || adaptorClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2015,"Values": [parseInt(adaptorClientsFieldValue)]});
     }
     if( adaptorClientsFieldValue instanceof Array && adaptorClientsFieldValue.length > 0){
       if(typeof adaptorClientsFieldValue[0] === 'object' && adaptorClientsFieldValue.length === 1){
         let obj = adaptorClientsFieldValue[0];
         items.push({"SearchProperty": 2015,"Values": [obj.value]});
       }
       if(typeof adaptorClientsFieldValue[0] === 'object' && adaptorClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<adaptorClientsFieldValue.length;i++){
           newArr.push(adaptorClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2015,"Values": newArr});
       }
     }
   }

   if(adaptorDoNotUseFieldValue){
     items.push({"SearchProperty": 2017,"Values": [parseInt(1)]});
   }


   if(soundEngineerDialogueRecordingExperienceFieldValue){
     items.push({"SearchProperty": 2601,"Values": [parseInt(1)]});
   }
   if(soundEngineerSongRecordingExperienceFieldValue){
     items.push({"SearchProperty": 2602,"Values": [parseInt(1)]});
   }
   if(soundEngineerDialogueMixingExperienceFieldValue){
     items.push({"SearchProperty": 2603,"Values": [parseInt(1)]});
   }
   if(soundEngineerSongMixingExperienceFieldValue){
     items.push({"SearchProperty": 2604,"Values": [parseInt(1)]});
   }
   if(soundEngineerAudioDescriptionMixingExperienceFieldValue){
     items.push({"SearchProperty": 2605,"Values": [parseInt(1)]});
   }
   if(soundEngineerRemoteRecordingCapabilityFieldValue){
     items.push({"SearchProperty": 2606,"Values": [parseInt(soundEngineerRemoteRecordingCapabilityFieldValue)]});
   }
   if(soundEngineerDubbingExperienceFieldValue){
     items.push({"SearchProperty": 2607,"Values": [parseInt(1)]});
   }
   if(soundEngineerVoiceOverExperienceFieldValue){
     items.push({"SearchProperty": 2608,"Values": [parseInt(1)]});
   }
   if(soundEngineerSongsExperienceFieldValue){
     items.push({"SearchProperty": 2609,"Values": [parseInt(1)]});
   }
   if(soundEngineerProToolsExperienceFieldValue){
     items.push({"SearchProperty": 2610,"Values": [parseInt(1)]});
   }
   if(soundEngineerDolby51ExperienceFieldValue){
     items.push({"SearchProperty": 2611,"Values": [parseInt(1)]});
   }
   if(soundEngineerAtmosExperienceFieldValue){
     items.push({"SearchProperty": 2612,"Values": [parseInt(1)]});
   }
   if(soundEngineerFoleyExperienceFieldValue){
     items.push({"SearchProperty": 2613,"Values": [parseInt(1)]});
   }
   if(soundEngineerStudiosFieldValue){
     if (typeof soundEngineerStudiosFieldValue === 'string' || soundEngineerStudiosFieldValue instanceof String){
        items.push({"SearchProperty": 2614,"Values": [parseInt(soundEngineerStudiosFieldValue)]});
     }
     if( soundEngineerStudiosFieldValue instanceof Array && soundEngineerStudiosFieldValue.length > 0){
       if(typeof soundEngineerStudiosFieldValue[0] === 'object' && soundEngineerStudiosFieldValue.length === 1){
         let obj = soundEngineerStudiosFieldValue[0];
         items.push({"SearchProperty": 2614,"Values": [obj.value]});
       }
       if(typeof soundEngineerStudiosFieldValue[0] === 'object' && soundEngineerStudiosFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<soundEngineerStudiosFieldValue.length;i++){
           newArr.push(soundEngineerStudiosFieldValue[i].value);
         }
         items.push({"SearchProperty": 2614,"Values": newArr});
       }
     }
   }

   if(soundEngineerClientsFieldValue){
     if (typeof soundEngineerClientsFieldValue === 'string' || soundEngineerClientsFieldValue instanceof String){
        items.push({"SearchProperty": 2615,"Values": [parseInt(soundEngineerClientsFieldValue)]});
     }
     if( soundEngineerClientsFieldValue instanceof Array && soundEngineerClientsFieldValue.length > 0){
       if(typeof soundEngineerClientsFieldValue[0] === 'object' && soundEngineerClientsFieldValue.length === 1){
         let obj = soundEngineerClientsFieldValue[0];
         items.push({"SearchProperty": 2615,"Values": [obj.value]});
       }
       if(typeof soundEngineerClientsFieldValue[0] === 'object' && soundEngineerClientsFieldValue.length > 1){
         let newArr=[];
         for(let i=0;i<soundEngineerClientsFieldValue.length;i++){
           newArr.push(soundEngineerClientsFieldValue[i].value);
         }
         items.push({"SearchProperty": 2615,"Values": newArr});
       }
     }
   }

   if(soundEngineerDoNotUseFieldValue){
     items.push({"SearchProperty": 2617,"Values": [parseInt(1)]});
   }



    data = {
      "FullTextSearch": '',
      "Items": items
    }



    // this.props.ajax.get(searchUrl, true, (data) => {
    //   data.forEach((el, index) => {
    //     return data[index].NavigationParam = data[index].Id;
    //   });
    //
    //   this.props.fetchVacancySkillVendorsByCriteriaSuccess(data);
    // })
      console.log(data);


    this.setState({dataSearch: data});

    //this.props.setCriteriaData(true);

    //counters section-------------

    //personalCounter
    let personalCounterArr = [];
    data.Items.map((element) =>{
        if(element.SearchProperty <25 && element.SearchProperty !== 17 && element.SearchProperty !== 18 && element.SearchProperty !== 19 && element.SearchProperty !== 22 && element.SearchProperty !== 20){
        if(element.SearchProperty == 5 && element.Values[0] ==10 ){
        }else{
          personalCounterArr.push(element.SearchProperty);
        }
      }
    });
    this.setState({personalCounter: personalCounterArr.length});

    this.setState({directorCounter: this.countSelectedFilters(data.Items, '22')});
    this.setState({translatorCounter: this.countSelectedFilters(data.Items, '27')});
    this.setState({adaptorCounter: this.countSelectedFilters(data.Items, '20')});
    this.setState({lyricistCounter: this.countSelectedFilters(data.Items, '24')});
    this.setState({actorCounter: this.countSelectedFilters(data.Items, '28')});
    this.setState({singerCounter: this.countSelectedFilters(data.Items, '25')});
    this.setState({editorCounter: this.countSelectedFilters(data.Items, '23')});
    this.setState({soundEngineerCounter: this.countSelectedFilters(data.Items, '26')});
    this.setState({bookerCounter: this.countSelectedFilters(data.Items, '21')});

    //castCounter
    let castCounterArr = [];
    data.Items.map((element) =>{
      let str = element.SearchProperty.toString();
      if(str.substring(0,2) == '17' || str.substring(0,2) == '18' || str.substring(0,2) == '19'){
          castCounterArr.push(element.SearchProperty);
      }
    });
    this.setState({castCounter: castCounterArr.length});
    //end counter section--------------

    this.props.ajax.post(
        url,
      JSON.stringify(data),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if(response){
          if(response.length){
            response.forEach((el, index) => {
              return (response[index].NavigationParam = response[index].Id);
            });
            this.setState({
              items: response
            });
          }
          else{
              this.setState({items: []});
          }

        }
      }, true)
  }


  onSave(){
    if(this.state.dataSearch == ''){
      return alert('Set criteria before saving');
    }
    //check it
    this.props.notify('Criteria were saved.');
    let url = 'vacancies/' + this.props.vacancyId + '/saveCriteria';

    console.log(this.state.dataSearch);

    this.props.ajax.put(url,
      JSON.stringify(this.state.dataSearch),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }, null, true, true, () => {
      //this.props.notify('Criteria were saved.');
    })

}

  toggleBasicDetails() {
    this.setState({ collapseBasicDetails: !this.state.collapseBasicDetails });
  }

  toggleVoiceActor() {
    this.setState({ collapseVoiceActor: !this.state.collapseVoiceActor });
  }
  toggleCast() {
    this.setState({ collapseCast: !this.state.collapseCast });
  }
  toggleBooker() {
    this.setState({ collapseBooker: !this.state.collapseBooker });
  }
  toggleSinger() {
    this.setState({ collapseSinger: !this.state.collapseSinger });
  }
  toggleDirector() {
    this.setState({ collapseDirector: !this.state.collapseDirector });
  }
  toggleLyricist() {
    this.setState({ collapseLyricist: !this.state.collapseLyricist });
  }
  toggleTranslator() {
    this.setState({ collapseTranslator: !this.state.collapseTranslator });
  }
  toggleEditor() {
    this.setState({ collapseEditor: !this.state.collapseEditor });
  }
  toggleAdaptor() {
    this.setState({ collapseAdaptor: !this.state.collapseAdaptor });
  }
  toggleSoundEngineer() {
    this.setState({ collapseSoundEngineer: !this.state.collapseSoundEngineer });
  }

  render() {
    let fields = this.props.fields;

    // //external experience
    // fields[41].value = this.state.externalExperience;
    // console.log(fields[41]);


    let arrowIconBasicDetails = this.state.collapseBasicDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconVoiceActor = this.state.collapseVoiceActor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconCast = this.state.collapseCast ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconBooker = this.state.collapseBooker ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconSinger = this.state.collapseSinger ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconDirector = this.state.collapseDirector ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconLyricist = this.state.collapseDirector ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconTranslator = this.state.collapseTranslator ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconEditor = this.state.collapseEditor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconAdaptor = this.state.collapseAdaptor ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    let arrowIconSoundEngineer = this.state.collapseSoundEngineer ? 'keyboard_arrow_down' : 'keyboard_arrow_up';

  //console.log(fields);

  //isFixed
  fields.find(f => f.name === 'SkillTypeFixed').value = this.props.overview.SkillTypeLabel;
    return (
      <div className="row">
        <div className="col-3" style={{overflow: "auto", maxHeight:"850px", fontSize: "0.8rem"}}>
        <SearchForm fields={fields} onSearch={this.onSearch} onSave={this.onSave}>
          <div className="talent-search">
            <div className="row">
              <div className="col-11">
                <InputField field={fields[155]} isFixed={true} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
              </div>
            </div>
            <div className="row">
              <div className="col-11">
                <MultiSelect field={fields[38]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
              </div>
            </div>
            <div className="row">
              <div className="col-11">
                <MultiSelect field={fields[0]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
              </div>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleBasicDetails}>
                <i className="material-icons">{arrowIconBasicDetails}</i>
                <span>Personal & basic info {this.state.personalCounter?'(' + this.state.personalCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseBasicDetails} className="mb-4">
                 <Card>
                     <CardBody>
                       <div className="row">
                         <div className="col-11">
                           <Select field={fields[1]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[2]} validate={this.props.validateVacancyCriteriaVoiceActorField}search={this.onSearch} />
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-5">
                           <Select field={fields[3]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                         </div>
                         <div className="col-1"></div>
                         <div className="col-5">
                           <Select field={fields[4]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[5]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[6]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[7]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                         </div>
                       </div>
                       { this.props.ethnicityExists &&
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[8]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                           </div>
                         </div>
                        }
                        { this.props.identityExists &&
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[9]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                           </div>
                         </div>
                        }
                       <div className="talent-search-group">
                        <label className="col-form-label">Status</label>
                          <div className="row">
                            <div className="col-11">
                              <CheckboxField field={fields[10]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-11">
                              <CheckboxField field={fields[11]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                            </div>
                          </div>
                          {/*<div className="row">
                            <div className="col-11">
                              <CheckboxField field={fields[12]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                            </div>
                          </div>*/}
                       </div>
                     </CardBody>
                  </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleVoiceActor}>
                <i className="material-icons">{arrowIconVoiceActor}</i>
                <span>Actor {this.state.actorCounter?'(' + this.state.actorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseVoiceActor} className="mb-4">
                 <Card>
                     <CardBody>
                     <div className="talent-search-group">
                      <label className="col-form-label">Status</label>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField field={fields[164]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                          </div>
                        </div>
                     </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Voice gender (L/A)</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[13]} checked={this.props.liveActionVoiceGenderMale} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[14]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[154]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Voice gender (Animation)</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[15]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[16]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[154]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[17]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[18]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       { this.props.languageAccent &&
                         <div className="row">
                           <div className="col-11">
                             <MultiSelect field={fields[19]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       }
                       <div className="talent-search-group">
                         <label className="col-form-label">Productions</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[20]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[21]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[22]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[23]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Genres</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[24]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[25]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Experience</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[26]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[27]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[28]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[29]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[30]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                            <CheckboxField field={fields[31]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[32]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} option={this.props.voiceActorStudio} field={fields[33]} getSelectedOption={this.getVoiceActorStudioId} search={this.onSearch}/>
                      </div>
                      </div>
                      <div className="row">
                       <div className="col-11">
                         <MultiSelectAutoComplete clear={this.state.clear} field={fields[34]} option={this.props.voiceActorClient}  getSelectedOption={this.getVoiceActorClientId} search={this.onSearch}/>
                       </div>
                      </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[35]} option={this.props.voiceActorSchool}  getSelectedOption={this.getVoiceActorSchoolId} search={this.onSearch}/>
                        </div>
                       </div>
                      { this.props.isVoiceActorUnion &&
                        <div className="row">
                          <div className="col-11">
                            <MultiSelect field={fields[36]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                          </div>
                        </div>
                      }
                      <div className="row">
                        <div className="col-11">
                          <ReactSelectTalentSearch field={fields[37]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                     </CardBody>
                  </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleDirector}>
                <i className="material-icons">{arrowIconDirector}</i>
                <span>Director {this.state.directorCounter?'(' + this.state.directorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseDirector} className="mb-4">
                 <Card>
                   <CardBody>
                       <div className="talent-search-group">
                        <label className="col-form-label">Status</label>
                          <div className="row">
                            <div className="col-11">
                              <CheckboxField field={fields[158]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                            </div>
                          </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Productions</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[60]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[61]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[62]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[63]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Genres</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[64]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[65]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Experience</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[66]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[67]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[68]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[69]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[70]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[71]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[72]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[73]} option={this.props.directorStudio}  getSelectedOption={this.getDirectorStudioId} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[74]} option={this.props.directorClient}  getSelectedOption={this.getDirectorClientId} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[75]} option={this.props.directorSchool}  getSelectedOption={this.getDirectorSchoolId} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <ReactSelectTalentSearch field={fields[76]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                      <div className="row">
                        <div className="col-11 mt-2">
                          <ReactSelectTalentSearch field={fields[77]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleLyricist}>
                <i className="material-icons">{arrowIconLyricist}</i>
                <span>Lyricist {this.state.lyricistCounter?'(' + this.state.lyricistCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseLyricist} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[160]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                   </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[78]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[79]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[80]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[81]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[82]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[83]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[84]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[85]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                     <div className="col-11">
                       <MultiSelectAutoComplete clear={this.state.clear} field={fields[86]} option={this.props.lyricistStudio}  getSelectedOption={this.getLyricistStudioId} search={this.onSearch}/>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[87]}option={this.props.lyricistClient}  getSelectedOption={this.getLyricistClientId} search={this.onSearch}/>
                      </div>
                     </div>
                    <div className="row">
                      <div className="col-11">
                        <ReactSelectTalentSearch field={fields[88]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleTranslator}>
                <i className="material-icons">{arrowIconTranslator}</i>
                <span>Translator {this.state.translatorCounter?'(' + this.state.translatorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseTranslator} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[163]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                   </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[89]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[90]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[91]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[92]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Genres</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[93]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[94]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[95]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[96]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[97]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[98]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[99]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[100]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[101]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-11">
                        <MultiSelect field={fields[102]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                    </div>
                    <div className="row">
                     <div className="col-11">
                       <MultiSelectAutoComplete clear={this.state.clear} field={fields[103]} option={this.props.translatorStudio}  getSelectedOption={this.getTranslatorStudioId} search={this.onSearch}/>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[104]} option={this.props.translatorClient}  getSelectedOption={this.getTranslatorClientId} search={this.onSearch}/>
                      </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleSoundEngineer}>
                <i className="material-icons">{arrowIconSoundEngineer}</i>
                <span>Sound engineer {this.state.soundEngineerCounter?'(' + this.state.soundEngineerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseSoundEngineer} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[162]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Productions</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[137]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[138]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[139]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Skills</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[140]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[141]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[142]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[143]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="talent-search-group">
                     <label className="col-form-label">Experience</label>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[144]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[145]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[146]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[147]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[148]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[149]} option={this.props.soundEngineerStudio}  getSelectedOption={this.getSoundEngineerStudioId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[150]} option={this.props.soundEngineerClient}  getSelectedOption={this.getSoundEngineerClientId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[151]} option={this.props.soundEngineerSchool}  getSelectedOption={this.getSoundEngineerSchoolId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <ReactSelectTalentSearch field={fields[152]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleAdaptor}>
                <i className="material-icons">{arrowIconAdaptor}</i>
                <span>Adaptor {this.state.adaptorCounter?'(' + this.state.adaptorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseAdaptor} className="mb-4">
                 <Card>
                   <CardBody>
                       <div className="talent-search-group">
                        <label className="col-form-label">Status</label>
                          <div className="row">
                            <div className="col-11">
                              <CheckboxField field={fields[156]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                            </div>
                          </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Productions</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[122]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[123]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[124]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[125]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Genres</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[126]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[127]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="talent-search-group">
                         <label className="col-form-label">Experience</label>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[128]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[129]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[130]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[131]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                         <div className="row">
                           <div className="col-11">
                             <CheckboxField field={fields[132]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                           </div>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelect field={fields[133]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[134]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[135]} option={this.props.adaptorStudio} getSelectedOption={this.getAdaptorStudioId} search={this.onSearch}/>
                        </div>
                       </div>
                       <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[136]} option={this.props.adaptorClient}  getSelectedOption={this.getAdaptorClientId} search={this.onSearch}/>
                        </div>
                       </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleEditor}>
                <i className="material-icons">{arrowIconEditor}</i>
                <span>Dialogue Editor {this.state.editorCounter?'(' + this.state.editorCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseEditor} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[159]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Productions</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[105]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[106]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[107]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                       <label className="col-form-label">Skills</label>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[108]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[109]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[110]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col-11">
                           <CheckboxField field={fields[111]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[112]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[113]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[114]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[115]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[116]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-11">
                        <CheckboxField field={fields[117]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                      </div>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[118]} option={this.props.editorStudio} getSelectedOption={this.getEditorStudioId} search={this.onSearch}/>
                      </div>
                    </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[119]} option={this.props.editorClient}  getSelectedOption={this.getEditorClientId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[120]} option={this.props.editorSchool}  getSelectedOption={this.getEditorSchoolId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <ReactSelectTalentSearch field={fields[121]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleSinger}>
                <i className="material-icons">{arrowIconSinger}</i>
                <span>Singer {this.state.singerCounter?'(' + this.state.singerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseSinger} className="mb-4">
                 <Card>
                   <CardBody>
                   <div className="talent-search-group">
                    <label className="col-form-label">Status</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[161]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                   </div>
                     <div className="talent-search-group">
                     <label className="col-form-label">Voice gender</label>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[46]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[47]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <CheckboxField field={fields[153]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[48]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[49]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="row">
                       <div className="col-11">
                         <MultiSelect field={fields[50]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                       </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[51]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[52]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[53]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <CheckboxField field={fields[54]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[55]} option={this.props.singerStudio}   getSelectedOption={this.getSingerStudioId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[56]} option={this.props.singerClient}   getSelectedOption={this.getSingerClientId} search={this.onSearch}/>
                      </div>
                     </div>
                     <div className="row">
                      <div className="col-11">
                        <MultiSelectAutoComplete clear={this.state.clear} field={fields[57]} option={this.props.singerSchool}   getSelectedOption={this.getSingerSchoolId} search={this.onSearch}/>
                      </div>
                     </div>
                     { this.props.isSingerUnion &&
                       <div className="row">
                         <div className="col-11">
                           <MultiSelect field={fields[58]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                         </div>
                       </div>
                     }
                      <div className="row">
                        <div className="col-11">
                          <ReactSelectTalentSearch field={fields[59]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleBooker}>
                <i className="material-icons">{arrowIconBooker}</i>
                <span>Booker {this.state.bookerCounter?'(' + this.state.bookerCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseBooker} className="mb-4">
                 <Card>
                   <CardBody>
                     <div className="talent-search-group">
                      <label className="col-form-label">Status</label>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField field={fields[157]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                          </div>
                        </div>
                     </div>
                     <div className="talent-search-group">
                      <label className="col-form-label">Experience</label>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField field={fields[42]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField field={fields[43]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-11">
                            <CheckboxField field={fields[44]} validate={this.props.validateVacancyCriteriaVoiceActorField} search={this.onSearch}/>
                          </div>
                        </div>
                        <div className="row mt-3">
                         <div className="col-11">
                           <MultiSelectAutoComplete clear={this.state.clear} option={this.props.bookerStudio} field={fields[45]} getSelectedOption={this.getVoiceActorStudioId} search={this.onSearch}/>
                         </div>
                         </div>
                     </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
            <div>
              <a type="button" className="btn btn-primary btn-flat btn-icon" onClick={this.toggleCast}>
                <i className="material-icons">{arrowIconCast}</i>
                <span>Cast {this.state.castCounter?'(' + this.state.castCounter + ')':''}</span>
              </a>
              <Collapse isOpen={this.state.collapseCast} className="mb-4">
                 <Card>
                   <CardBody>
                      <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} option={this.props.productionCast} field={fields[39]}  getSelectedOption={this.getProductionId} search={this.onSearch}/>
                        </div>
                      </div>
                      <div className="row">
                       <div className="col-11">
                         <MultiSelectAutoComplete clear={this.state.clear} option={this.props.vacancyCast} field={fields[40]}  getSelectedOption={this.getVacancyId} search={this.onSearch}/>
                       </div>
                      </div>
                      <div className="row">
                        <div className="col-11">
                          <MultiSelectAutoComplete clear={this.state.clear} field={fields[41]} option={this.props.externalExperienceCast}  getSelectedOption={this.getExternalExperienceId} search={this.onSearch}/>
                        </div>
                      </div>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
          </div>
        </SearchForm>
        </div>
        <div className="col-9">
          {this.props.url != null &&
            <div>
              <VoiceTestCriteriaResult result={this.state.items} />
              <div className="row">
                <div className="col">
                  <br />
                  {(this.props.overview.Status === 'Draft' || this.props.overview.Status === 'Active') &&
                    <ProtectedElement permission={PERMISSION_VACANCIES_CRITERIA_WRITE}>
                      <button id="Save" className="btn btn-rounded btn-primary" onClick={this.onSave}>Save</button>
                    </ProtectedElement>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  fields: state.voiceTestAndVacancyCriteria.fields,
  overview: state.voiceTestPage.overview
})
const mapDispatchToProps = dispatch => ({
  validateVacancyCriteriaVoiceActorField(value, field) { dispatch(validateVacancyCriteriaVoiceActorField(value, field)) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(VoiceTestSoundEngineerCriteria)
